import { WritableDraft, produce } from 'immer'
import { v4 as uuidV4 } from 'uuid'

import { MessageType } from '../../../common/ai.dictionary'
import { AiState } from '../../ai.state'

export const onAgentFailure = (
  state: AiState,
  { errorMsg }: { statusCode: number; errorMsg?: any }
): AiState =>
  produce(state, (draft: AiState) => {
    draft.messages.push({
      message: errorMsg || '',
      type: MessageType.SystemMsg,
    })
  })

export const closeChat = (draft: WritableDraft<AiState>): void => {
  newChatSession(draft)

  draft.selectedAgent = null
  draft.sessionId = null
  // draft.messages = [] BR - temporary fix
}

export const newChatSession = (draft: WritableDraft<AiState>): void => {
  draft.selectedDocument = null
  draft.selectedDocumentContext = null
  draft.selectedDesignerUserTaskAreaId = null
  draft.selectedDesignerTemplateConfigId = null
  draft.sessionId = uuidV4()
  draft.isAiInteractionAllowed = true
  draft.isFileUploadAllowed = true
  draft.isChatConversationAllowed = true
  draft.uploadedFiles = []
  draft.generatedProcess = null
  draft.temporaryProcess = null
  draft.startedFromSequence = null
  draft.generatedSequenceProcess = null
  draft.generatedProcessEntities = null
  draft.temporaryProcessEntities = null
  draft.generatedProcessPreviewHeader = null
  draft.generatedEnumeration = null
  draft.currentEnumeration = null
  draft.currentNotification = null
  draft.generatedUI = null
  draft.generatedUINew = null
  draft.temporaryUI = null
  draft.generatedEditDiff = null
  draft.editDiffAppliedConfig = null
  draft.currentFullUI = null
  draft.generatedUIDataModelChanges = null
  draft.generatedBusinessRule = null
  draft.generatedTestData = null
  draft.generatedFixWarningsBusinessRule = null
  draft.generatedFixErrorBusinessRule = null
  draft.generatedExpression = null
  draft.generatedImprovedCode = null
  draft.generatedAddComment = null
  draft.draftMessage = null
  draft.initialMessage = null
  draft.isUploadingDocuments = false
  draft.pendingRouteToAssistant = null
  draft.pendingRouteToDesigner = null
  draft.pendingRouteToAnalyst = null
  draft.pendingRouteToDeveloper = null
  draft.pendingRouteToCoordinator = null
  draft.pendingRouteToArchitect = null
  draft.pendingAiResponse = false
  draft.pendingKeepDraftSave = false
}
